<template>
  <div>
    <VTextField
      id="starting_address"
      v-model="starting_address"
      :label="$t('forms.labels.typeYourAdress')"
      placeholder=""
      outlined
      data-cy="autocompleteGoogle"
      :disabled="disabled"
    />
  </div>
</template>

<script>

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        addTimezone: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            // Destination data items
            starting_address: '',
            temp_starting_address: '',
            objectsDatas: {},
            timezone: '',
        };
    },

    watch: {
        async objectsDatas() {
            this.sendDatas();
        },
        disabled: {
            handler(newValue, oldValue) {
                if (!oldValue && newValue) {
                    // from enabled to disabled
                    this.temp_starting_address = this.starting_address;
                    this.starting_address = '';
                } else if (oldValue && !newValue) {
                    // from disabled to enabled
                    this.starting_address = this.temp_starting_address;
                }
            },
        },
    },
    mounted() {
        this.initSearch();
    },

    methods: {
        async initSearch() {
            /* need that to access datas inside the function */
            const self = this;
            /* Google function getting adresses from 'starting_address' in data component */
            // eslint-disable-next-line camelcase
            const starting_address_input = document.getElementById('starting_address');
            // eslint-disable-next-line camelcase, no-undef
            const starting_address_autocomplete = new google.maps.places.Autocomplete(starting_address_input, {
                types: ['address'],
            });
            /* Treatment datas that received */
            await starting_address_autocomplete.addListener('place_changed', async () => {
                const place = starting_address_autocomplete.getPlace();
                // Fetch timezone from backend
                await this.getTimezone(place.geometry?.location);
                const newDatas = { tz: self.timezone };

                /* Define element to keep for us */
                const elementsToKeep = ['street_number', 'route', 'postal_code', 'postal_code_prefix', 'locality', 'sublocality_level_1', 'administrative_area_level_1', 'administrative_area_level_2', 'country', 'administrative_area_level_3'];
                /* Temporary variable to keep datas before to send to data components */
                /* Get datas and push in temporary variable */
                elementsToKeep.forEach(element => {
                    const elt = place.address_components.filter(e => e.types[0] === element);

                    if (['administrative_area_level_1', 'administrative_area_level_2', 'administrative_area_level_3', 'country'].includes(element)) {
                        newDatas[element] = elt[0]?.short_name;
                    } else {
                        newDatas[element] = elt[0]?.long_name;
                    }
                });
                if (place.geometry && place.geometry.location) {
                    newDatas.locationGPS = {
                        latitude: place.geometry.location.lat(),
                        longitude: place.geometry.location.lng(),
                    };
                }
                /* Save datas in component data */
                self.objectsDatas = newDatas;
            });

            this.sendDatas();
        },

        sendDatas() {
            this.$emit('change', this.objectsDatas);
        },
        async getTimezone(location) {
            if (!this.addTimezone || !location?.lat || !location?.lat) {
                return;
            }
            const { data } = await this.$rq.getTimezone(location.lat(), location.lng());

            this.timezone = data.timezone;
        },
    },
};
</script>
